import React from "react";
import { Link } from "react-router-dom";

function WhatWastheBetterDecision() {
  document.title = "SimWealth";
  return (
    <>
      <div className="bg bg-what-was-the-better-decision">
      <div data-aos="fade-right" className="container d-flex flex-column align-items-start justify-content-start vh-100 w-100">
            <div className="row d-flex justify-content-center align-items-start my-auto text-center w-40">
                <div className="bg-white rounded-border py-3 border border-4 border-dark px-2">
                <h4 className='ModalTitle fw-bold heading-font'>What Was the Better Decision?</h4>
                    <div className="px-4 fs-14">
                    <p >Even though both friends purchased identical properties, Sam made the decision to use a well-structured mortgage.</p>
                    <b className="text-center d-block mt-3">Lesson 1: </b>
                    <p>Sam realized there is a big difference between “making money” versus “purchasing power”, a key distinction most investors are not aware of.</p>
                    <b className="text-center d-block mt-3">Lesson 2: </b>
                    <p>Well-structured mortgages serve as an “inflation shield”, strategically passing the negative impact of inflation back to the lender.</p>
                    <p>Having a well–structured debt is like wearing an inflation-proof vest. This allows Sam to move faster towards his financial goals with a lot less “friction” from inflation.</p>
                    <b className="text-center d-block mt-3">Lesson 3: </b>
                    <p>By using a mortgage, Sam improved his purchasing power significantly, and ultimately his financial future.</p>
                    <p>Dave never realized that the invisible force of inflation was pushing him back the whole time.</p>
                    </div>
                    <div className="d-flex justify-content-center align-items-center mx-1 gap-2 ">
                    <button className="yellowBtn">Download Explainer Ebook</button>
                    <Link to={'/choose-a-simulation'} className="threeDButton btn">Try Another Simulation</Link>
                    <Link to={'/personalize-simulation'} className=" threeDButton btn">Personalize Simulation</Link>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </>
  );
}

export default WhatWastheBetterDecision;
